export default {
  "toast": "_toast_x8axpt",
  "info": "_info_x8axpt",
  "success": "_success_x8axpt",
  "error": "_error_x8axpt",
  "icon": "_icon_x8axpt",
  "message": "_message_x8axpt",
  "close": "_close_x8axpt"
};